import React from 'react';

import CPCReferenciaWinterList  from 'components/Tvendo/Sale/QuotaBPartner/Winter/CoberturaReferencia/List.js';

export default function () {
  return <CPCReferenciaWinterList  />;
}